/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 本日出荷数に予測値を使用
 * @export
 * @interface TodayShipRecDelayFlg
 */
export interface TodayShipRecDelayFlg {
}

/**
 * Check if a given object implements the TodayShipRecDelayFlg interface.
 */
export function instanceOfTodayShipRecDelayFlg(value: object): value is TodayShipRecDelayFlg {
    return true;
}

export function TodayShipRecDelayFlgFromJSON(json: any): TodayShipRecDelayFlg {
    return TodayShipRecDelayFlgFromJSONTyped(json, false);
}

export function TodayShipRecDelayFlgFromJSONTyped(json: any, ignoreDiscriminator: boolean): TodayShipRecDelayFlg {
    return json;
}

export function TodayShipRecDelayFlgToJSON(json: any): TodayShipRecDelayFlg {
    return TodayShipRecDelayFlgToJSONTyped(json, false);
}

export function TodayShipRecDelayFlgToJSONTyped(value?: TodayShipRecDelayFlg | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

